<!--Bar for screens loaded in non-Express environments (i.e. Incode shell)-->
<!-- TODO For Angular update, use Forge toolbar instead of mat-toolbar -->
<ng-container *ngIf="isEmbedded; else fullBar">
    <mat-toolbar *ngIf="showBackBar">
        <forge-icon-button (click)="back()">
            <button telemetry="Submission-Back">
                <forge-icon name="arrow_back"></forge-icon>
            </button>
        </forge-icon-button>
    </mat-toolbar>
</ng-container>

<ng-template #fullBar>
    <forge-app-bar id="app-bar" [ngClass]="omniBarClasses">
        <forge-icon-button *ngIf="authenticated && !isVendorUser && !isEscalationChat" slot="start" #omnibarMenu id="omnibarMenu"
                           [disabled]="menuDisabled" (click)="toggleMenu()" aria-keyshortcuts="Control+F2"
                           aria-label="toggle navigation menu">
            <forge-icon name="menu"></forge-icon>
            <forge-tooltip>Open menu (Ctrl + F2)</forge-tooltip>
        </forge-icon-button>

        <a slot="logo" [href]="getDefaultAppUrl()" tabindex="0" aria-label="Link to My Dashboard">
            <forge-icon name="tyler_talking_t_logo"></forge-icon>
        </a>

        <a tabindex="0" (click)="reload()" role="link" slot="title" attr.aria-label="reload {{omniTitle}}"
           telemetry="Submission-Reload">
            <div class="forge-typography--heading4 header-text">{{omniTitle}}</div>
        </a>

        <omni-search *ngIf="authenticated && allowSearch && !isEscalationChat" slot="center" [commandKey]="commandKey"></omni-search>

        <ng-container *ngIf="!isVendorUser && !isEscalationChat">
            <conn-group-action *ngIf="authenticated" slot="end">
            </conn-group-action>

            <support-chat slot="end">
            </support-chat>

            <help-menu slot="end">
            </help-menu>

            <nine-box slot="end">
            </nine-box>
        </ng-container>

        <profile-menu *ngIf="authenticated && !isEscalationChat" slot="end">
        </profile-menu>
    </forge-app-bar>

    <forge-inline-message *ngIf="isProvisional" class="provisional">
        <div>This is a provisional database. Any transactions will not impact live data.</div>
    </forge-inline-message>
</ng-template>
